export const SIDEBAR_PARENT_MENUS = {
  developer: {
    i18nKey: "page.developer.title",
    icon: "bi-code-slash",
    sortOrder: 7,
    visibleWhen: ["hasDetectionApiAccess", "isStaging"],
  },
  archives: {
    i18nKey: "page.archive.titlePlural",
    icon: "bi-archive",
    sortOrder: 3,
    visibleWhen: [],
  },
};
